module.exports = __webpack_public_path__ + "static/media/supplier-icon1.3ab67461.svg";